export * from './personal-info.component';
